/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { Flex, Grid, Text } from '@chakra-ui/layout'
import { Accordion, AccordionButton, AccordionItem, AccordionPanel, Avatar, AvatarGroup, Box, useToast } from '@chakra-ui/react'
import { useEffect, useState } from 'react'
import { FaChevronDown, FaChevronRight, FaEye, FaFileDownload, FaFileUpload, FaFilter, FaMoneyBill } from 'react-icons/fa'
import { useNavigate } from 'react-router'
import { ButtonCmp } from '../../../components/ButtonCmp'
import { ElementoTooltipCmp } from '../../../components/ElementoTooltipCmp'
import LoadingContainer from '../../../components/LoadingContainer'
import { NavLine } from '../../../components/NavLine'
import { SearchCmp } from '../../../components/SearchCmp'
import { SelectCmp } from '../../../components/SelectCmp'
import { Tag } from '../../../components/Tag'
import { WhiteContainer } from '../../../components/WhiteContainer'
import { DescricaoCargo, iColaboradorSalario, iNomeId } from '../../../interfaces'
import { appApi } from '../../../services/appApi'
import { formatNumberBR } from '../../../Utils/Helper'
import { Body } from '../../Layouts/Body'
import { Sidebar } from '../Gestao/components/Sidebar'
import { CustoSalarialMensal } from './components/CustoSalarialMensal'
import { DrawerFiltro, iFiltro } from './components/DrowerFiltro'
import { GraficoDistribuicaoSalarios } from './components/GraficoDistribuicaoSalario'
import { GraficoMediaPorGrupo } from './components/GraficoMediaPorGrupo'
import { ModalCadastroEmMassa } from './components/ModalCadastroEmMassa'
import { ModalVisualizarCargo } from './components/ModalCargo'
import { ModalDissidio } from './components/ModalDissidio'
import { iColaboradorSalarioInput, UpdateColaboradorModal } from './components/ModalUpdateColaborador'
import { ContainerFiltro } from './styles'

export const Salarios: React.FC = () => {
  const opcoesAtuacao = ['Administrativo', 'Produtivo']
  const opcoesHierarquia = [
    'Chefia',
    'Coordenação',
    'Direção',
    'Gerência',
    'Produtivo',
    'Super intendência',
    'Supervisão'
  ]
  const nav = useNavigate()
  const toast = useToast()
  const [IsLoading, setIsLoading] = useState(false)
  const [isCollapsed, setIsCollapsed] = useState(false)
  const [ModalDissidioIsOpen, setModalDissidioIsOpen] = useState(false)
  const [Cargos, setCargos] = useState<DescricaoCargo[]>([])
  const [cargosFiltrados, setCargosFiltrados] = useState<DescricaoCargo[]>([])
  const [CargoSelecionado, setCargoSelecionado] = useState<DescricaoCargo>()
  const [NivelSelecionado, setNivelSelecionado] = useState<string>()
  const [Colaborador, setColaborador] = useState<iColaboradorSalario>()
  const [Tags, setTags] = useState<string[]>([])
  const [Busca, setBusca] = useState<string>('')
  const [DrowerIsOpen, setDrowerIsOpen] = useState(false)
  const [IsLoadingGraph, setIsLoadingGraph] = useState(false)
  const [Departamentos, setDepartamentos] = useState<iNomeId[]>([])
  const [ModalCadastroIsOpen, setModalCadastroIsOpen] = useState(false)
  const [Filtro, setFiltro] = useState<iFiltro>({
    areas: [],
    cargos: [],
    atuacao: [],
    hierarquia: [],
    nomeCargo: ''
  })

  function ObterTags(model: iFiltro): void {
    const tags: string[] = []

    if (model.areas.length > 0) {
      const nomesAreas = Departamentos
        .filter(area => model.areas.includes(area.id))
        .map(area => area.nome)
      tags.push(...nomesAreas)
    }

    if (model.cargos.length > 0) {
      const nomesCargos = Cargos
        .filter(cargo => model.cargos.includes(cargo.id))
        .map(cargo => cargo.nomeCargo)
      tags.push(...nomesCargos)
    }

    if (model.atuacao.length > 0) {
      const nomesAtuacao = opcoesAtuacao
        .filter(atu => model.atuacao.includes(atu))
      tags.push(...nomesAtuacao)
    }

    if (model.hierarquia.length > 0) {
      const nomesHierarquia = opcoesHierarquia
        .filter(h => model.hierarquia.includes(h))
      tags.push(...nomesHierarquia)
    }

    setTags(tags)
  }

  function GetDescritivos(): void {
    setIsLoading(true)

    appApi.get('api/CargosESalarios?popularColabs=true')
      .then((res) => {
        setCargos(res.data)
        setCargosFiltrados(res.data)
        setFiltro({
          areas: [],
          cargos: [],
          atuacao: [],
          hierarquia: [],
          nomeCargo: ''
        })
      })
      .catch(err => console.log(err))
      .finally(() => setIsLoading(false))
  }

  function OnUpdateColab(colab: iColaboradorSalarioInput): void {
    setIsLoading(true)

    appApi.put(`Colaborador/${colab.id}/CargoESalario`, { salario: colab.salario, nivel: colab.nivel, cargoESalarioId: colab.cargoESalarioId })
      .then(() => {
        toast({
          title: 'Colaborador realocado com sucesso',
          position: 'top',
          status: 'success',
          duration: 4000
        })
        GetDescritivos()
      })
      .catch(err => console.log(err))
      .finally(() => {
        setIsLoading(false)
        setColaborador(undefined)
      })
  }

  function getDepartamentos(): void {
    appApi.get('Departamento/Select')
      .then(res => {
        setDepartamentos(res.data)
      })
      .catch(err => console.log(err))
  }

  useEffect(() => {
    GetDescritivos()
    getDepartamentos()
  }, [])

  useEffect(() => {
    if (Cargos.length > 0) {
      setIsLoading(true)
      setTimeout(() => {
        setIsLoading(false)
      }, 300)
    }
  }, [isCollapsed])

  useEffect(() => {
    setIsLoadingGraph(true)
    setTimeout(() => {
      setIsLoadingGraph(false)
    }, 200)
  }, [CargoSelecionado, NivelSelecionado, isCollapsed, Colaborador, ModalCadastroIsOpen, DrowerIsOpen])

  useEffect(() => {
    if (Cargos.length > 0) {
      setCargosFiltrados(Cargos.filter(e => {
        let insideFilter = true
        if (Filtro.areas.length !== 0 && !Filtro.areas.some(f => e.trilhasDeCarreira.some(t => t.areaId === f))) {
          insideFilter = false
        }
        if (Filtro.atuacao.length !== 0 && !Filtro.atuacao.some(f => f === e.atuacao)) {
          insideFilter = false
        }
        if (Filtro.hierarquia.length !== 0 && !Filtro.hierarquia.some(f => f === e.nivelHierarquico)) {
          insideFilter = false
        }
        if (Filtro.cargos.length !== 0 && !Filtro.cargos.some(c => c === e.id)) {
          insideFilter = false
        }
        if (Filtro.nomeCargo !== '' && !e.nomeCargo.toLowerCase().includes(Filtro.nomeCargo.toLowerCase())) {
          insideFilter = false
        }

        return insideFilter ? e : null
      }))
      setIsLoadingGraph(true)
      setTimeout(() => {
        setIsLoadingGraph(false)
      }, 200)
    }
  }, [Filtro])

  return (
    <Flex justifyContent={'center'} alignItems={'self-start'} pos={'relative'} gap={'2rem'} margin={'0 auto'} pr={'2rem'}>
      <ModalCadastroEmMassa
        isOpen={ModalCadastroIsOpen}
        onRequestClose={() => setModalCadastroIsOpen(false)}
        reload={() => { GetDescritivos() }}
      />
      <ModalDissidio
        isOpen={ModalDissidioIsOpen}
        onClose={() => setModalDissidioIsOpen(false)}
        onSuccess={() => {
          setModalDissidioIsOpen(false)
          GetDescritivos()
        }}
      />
      <DrawerFiltro
        isOpen={DrowerIsOpen}
        onClose={() => setDrowerIsOpen(false)}
        onFilter={(filtro, isReset) => {
          setFiltro(filtro)
          if (isReset) {
            setBusca('')
          }
          toast({
            title: 'Filtros aplicados com sucesso',
            duration: 4000,
            position: 'top',
            status: 'success'
          })
          setDrowerIsOpen(false)
          ObterTags(filtro)
        }}
        areas={Departamentos}
        cargos={Cargos}
      />
      {NivelSelecionado && CargoSelecionado && <ModalVisualizarCargo
        cargo={CargoSelecionado}
        isOpen
        nivel={NivelSelecionado}
        onClose={() => {
          setNivelSelecionado(undefined)
          setCargoSelecionado(undefined)
        }}
      />}
      {Colaborador && <UpdateColaboradorModal
        isOpen
        onRequestClose={() => setColaborador(undefined)}
        colaborador={Colaborador}
        onUpdateEmployee={OnUpdateColab}
      />}
      <Flex
        position="sticky"
        top="0"
        left="0"
        direction="column"
        bg="white"
        transition="width 0.3s"
        width={isCollapsed ? '60px' : '220px'}
        height="100vh">
        <Sidebar isCollapsed={isCollapsed} onCollapse={setIsCollapsed} selecionado={'Salários'}/>
      </Flex>
      <Body isLoading={IsLoading} style={{ width: '100%' }} width={'100%'}>
        <Flex flexDir={'column'} gap={'1rem'} mb={'1rem'}>
          <Flex justifyContent={'space-between'}>
            <NavLine
              options={[
                {
                  nome: 'Cargos',
                  path: '/Descritivo/Cargos'
                },
                {
                  nome: 'Salários'
                }
              ]}
            />
            <Flex gap={'.75rem'} justifyContent='end'>
              <ButtonCmp VarColor='c6' onClick={() => nav(-1)}>Voltar</ButtonCmp>
              <ButtonCmp VarColor='Green2' leftIcon={<FaMoneyBill/>} onClick={() => setModalDissidioIsOpen(true)}>Calcular dissídio</ButtonCmp>
              <ButtonCmp OutlineColor='Rosa' leftIcon={<FaFileUpload/>} onClick={() => { window.location.href = `${process.env.REACT_APP_URL_API}/api/CargosESalarios/CSVColaboradores?token=${localStorage.getItem('token')}` }}>Exportar dados</ButtonCmp>
              <ButtonCmp OutlineColor='Rosa' leftIcon={<FaFileDownload/>} onClick={() => setModalCadastroIsOpen(true)}>Importar dados</ButtonCmp>
            </Flex>
          </Flex>
          <Flex justifyContent={'space-between'}>
            <h1>Gerenciamento de salários</h1>
          </Flex>
        </Flex>
        <WhiteContainer>
          <ContainerFiltro>
            <Flex justifyContent={'space-between'} alignItems={'center'} width={'100%'}>
              <Flex alignItems={'center'}>
                <Text fontWeight={'500'} fontSize='.875rem' paddingRight={'1rem'} borderRight={'2px solid var(--c5)'}>Filtros aplicados</Text>
                <Flex padding={'0 1rem'} gap={'1rem'}>
                  {Tags.length === 0 && <Tag>Nenhum filtro aplicado</Tag>}

                  {
                    Tags.map((e) => {
                      return (
                        <Tag>{e}</Tag>
                      )
                    })
                  }
                </Flex>
              </Flex>
              <Box color='var(--c6)' _hover={{ color: 'var(--Azul)' }}><FaFilter onClick={() => setDrowerIsOpen(true)} cursor={'pointer'} size={22} /></Box>
            </Flex>
          </ContainerFiltro>
        </WhiteContainer>
        <WhiteContainer margin='1rem 0 0 0'>
          <LoadingContainer loading={IsLoading || IsLoadingGraph} linhas={10}>
            <Flex gap={'1rem'} flexWrap="wrap">
              <CustoSalarialMensal cargos={cargosFiltrados} />

              <Flex
                flexDir="column"
                border={'1px solid var(--Azul)'}
                borderRadius={'.5rem'}
                p="1rem"
                minW="300px"
                flex="1"
                justify="center"
                align="center"
              >
                <Text mb="1rem" fontWeight="600">Análise salarial geral</Text>
                <GraficoDistribuicaoSalarios cargos={cargosFiltrados} />
              </Flex>

              <Flex
                flexDir="column"
                border={'1px solid var(--Azul)'}
                borderRadius={'.5rem'}
                p="1rem"
                minW="350px"
                flex="1"
                justify="center"
                align="center"
              >
                <Text mb="1rem" fontWeight="600">Média salarial em relação à mediana</Text>
                <GraficoMediaPorGrupo cargos={cargosFiltrados} />
              </Flex>
            </Flex>
          </LoadingContainer>
        </WhiteContainer>
        <Flex flexDir={'column'} gap={'1rem'} my={'1rem'}>
          <LoadingContainer loading={IsLoading} linhas={24}>
            {Cargos && (
              <WhiteContainer>
                <Flex justifyContent={'space-between'} alignItems={'end'}>
                  <h3 style={{ marginBottom: '1rem' }}>Lista de cargos</h3>
                  <Flex gap={'.75rem'} alignItems={'end'}>
                    <SearchCmp value={Busca} OnChange={setBusca} EnterAction={() => { setFiltro({ ...Filtro, nomeCargo: Busca }) }} placeholder={'Buscar pelo nome do cargo'}/>
                    <ButtonCmp VarColor='Green2' onClick={() => { setFiltro({ ...Filtro, nomeCargo: Busca }) }} leftIcon={<FaFilter/>}>Filtrar</ButtonCmp>
                  </Flex>
                </Flex>
                <Flex flexDir={'column'} border={'1px solid var(--c3)'} p={'.75rem'} borderRadius={'.25rem'} boxShadow={'var(--SombraBackground)'} mt={'1rem'}>
                  <Grid
                    gridTemplateColumns="1.5fr repeat(4, 1fr) 1fr .5fr"
                    px="1rem"
                    py=".75rem"
                    fontWeight="700"
                    color="var(--Gray3)"
                    gridGap={'1rem'}
                    borderBottom="1px solid var(--c6)"
                    w="100%"
                    fontSize={'14px'}
                  >
                    <Text>Cargo</Text>
                    <Text textAlign="center">Média em minha empresa</Text>
                    <Text textAlign="center">1º Quartil</Text>
                    <Text textAlign="center">Mediana</Text>
                    <Text textAlign="center">3º Quartil</Text>
                    <Text textAlign="center">Colaboradores</Text>
                  </Grid>

                  <Accordion allowToggle allowMultiple w="100%">
                    {
                      (() => {
                        let indexGlobal = 0

                        return cargosFiltrados.flatMap((cargo) =>
                          Object.entries(cargo.niveis).map(([nivelKey, nivel]) => {
                            const index = indexGlobal++
                            const colaboradoresNivel = cargo.colaboradores?.filter(c => c.nivel === nivelKey.replaceAll('_', ' ')) ?? []
                            const mediaSalarial = colaboradoresNivel.length
                              ? colaboradoresNivel.reduce((acc, col) => acc + (col.salario ?? 0), 0) / colaboradoresNivel.length
                              : 0

                            const isFirst = mediaSalarial <= nivel.primeiroQuartil
                            const isLast = mediaSalarial >= nivel.terceiroQuartil
                            const isMiddle = !isFirst && !isLast

                            return (
                              <AccordionItem key={`${cargo.id}-${nivelKey}`} border="none">
                                {({ isExpanded }) => (
                                  <>
                                    <Grid
                                      gridTemplateColumns="1.5fr repeat(4, 1fr) 1fr .5fr"
                                      alignItems="center"
                                      gap="1rem"
                                      px="1rem"
                                      py=".75rem"
                                      fontSize={'14px'}
                                      border={`1px solid ${isExpanded ? 'var(--Azul)' : 'var(--c2)'}`}
                                      bg={isExpanded ? 'var(--AzulOpacoBg)' : (index % 2 === 0) ? 'var(--c2)' : 'white'}
                                    >
                                      <Flex direction="column">
                                        <Text fontWeight={'600'}>{cargo.nomeCargo} - {nivelKey.replaceAll('_', ' ')}</Text>
                                      </Flex>

                                      <Flex justify="center" fontWeight={'600'}>
                                        R${formatNumberBR(mediaSalarial)}
                                      </Flex>

                                      <Flex justify="center" color={isFirst ? 'var(--Azul)' : 'inherit'}>
                                        R${formatNumberBR(nivel.primeiroQuartil)}
                                      </Flex>

                                      <Flex justify="center" color={isMiddle ? 'var(--Azul)' : 'inherit'}>
                                        R${formatNumberBR(nivel.mediana)}
                                      </Flex>

                                      <Flex justify="center" color={isLast ? 'var(--Azul)' : 'inherit'}>
                                        R${formatNumberBR(nivel.terceiroQuartil)}
                                      </Flex>

                                      <Flex justify="center">
                                        <AvatarGroup size="sm" max={4}>
                                          {colaboradoresNivel.map(col => (
                                            <Avatar key={col.id} name={col.nome} src={col.avatar} />
                                          ))}
                                        </AvatarGroup>
                                      </Flex>

                                      <Flex justify="center" align="center" gap=".5rem">
                                        <ElementoTooltipCmp bg={'var(--Rosa)'} label={'Visualizar cargo'}>
                                          <Flex
                                            alignItems={'center'}
                                            w={'1.75rem'}
                                            h={'1.75rem'}
                                            bg="transparent"
                                            border={'1px solid var(--Rosa)'}
                                            color={'var(--Rosa)'}
                                            borderRadius={'50%'}
                                            _hover={{ bg: 'var(--Rosa)', color: '#fff' }}
                                            _focus={{ boxShadow: 'none' }}
                                            justifyContent="center"
                                            transition={'.2s'}
                                            cursor={'pointer'}
                                            onClick={() => {
                                              setCargoSelecionado(cargo)
                                              setNivelSelecionado(nivelKey)
                                              setIsCollapsed(true)
                                            }}
                                          >
                                            <FaEye />
                                          </Flex>
                                        </ElementoTooltipCmp>
                                        <AccordionButton
                                            p={'.5rem'}
                                            w={'1.75rem'}
                                            h={'1.75rem'}
                                            bg="transparent"
                                            border={'1px solid var(--Green2)'}
                                            color={'var(--Green2)'}
                                            borderRadius={'50%'}
                                            _hover={{ bg: 'var(--Green2)', color: '#fff' }}
                                            _focus={{ boxShadow: 'none' }}
                                            justifyContent="center"
                                            transition={'.2s'}
                                          >
                                            <Box as={isExpanded ? FaChevronDown : FaChevronRight} />
                                        </AccordionButton>
                                      </Flex>
                                    </Grid>

                                    <AccordionPanel ml="1rem" my=".325rem" p={0} d={'flex'} flexDir='column' gap={'.325rem'}>
                                      {colaboradoresNivel.length === 0
                                        ? (
                                        <Text fontStyle="italic" color="var(--Gray3)" my={'1rem'} textAlign={'center'}>
                                          Nenhum colaborador alocado neste nível.
                                        </Text>
                                          )
                                        : (
                                            colaboradoresNivel.map(colab => {
                                              const salario = colab.salario ?? 0
                                              const isFirst = salario <= nivel.primeiroQuartil
                                              const isLast = salario >= nivel.terceiroQuartil
                                              const isMiddle = !isFirst && !isLast

                                              let corSalario = 'inherit'
                                              if (isFirst) corSalario = 'var(--Orange)'
                                              else if (isMiddle) corSalario = 'var(--Azul)'
                                              else if (isLast) corSalario = 'var(--Green3)'

                                              return (
                                            <Grid
                                              key={colab.id}
                                              gridTemplateColumns="1.325fr 2fr .325fr"
                                              alignItems="center"
                                              gap="1rem"
                                              py=".5rem"
                                              px={'1rem'}
                                              border={'1px solid var(--c2)'}
                                              borderLeft={'2px solid var(--Azul)'}
                                              fontSize="14px"
                                              bg={'var(--c2)'}
                                            >
                                              <Flex justifyContent={'space-between'} gap={'1rem'} alignItems={'center'} pr={'1rem'} maxW={'25rem'}>
                                                <Flex gap={'.75rem'}>
                                                  <Avatar name={colab.nome} src={colab.avatar} size="sm" />

                                                  <Flex direction="column">
                                                    <Text fontWeight="600">{colab.nome}</Text>
                                                    <Text color="var(--Gray3)" fontSize="12px">{colab.dataIngresso}</Text>
                                                  </Flex>
                                                </Flex>

                                                <Flex
                                                  ml={'.5rem'}
                                                  alignItems={'center'}
                                                  justifyContent={'center'}
                                                  px=".5rem"
                                                  py=".25rem"
                                                  borderRadius=".25rem"
                                                  bg={corSalario}
                                                  fontWeight="600"
                                                  color="white"
                                                  fontSize="14px"
                                                  textAlign="center"
                                                  w="fit-content"
                                                  h={'1.75rem'}
                                                >
                                                  R${formatNumberBR(salario)}
                                                </Flex>
                                              </Flex>

                                              <Flex direction="column" gap=".25rem" w={'85%'} maxW={'22rem'} mx={'auto'} justifyContent={'center'}>
                                                <Grid
                                                  templateColumns="repeat(3, 1fr)"
                                                  w="100%"
                                                  fontSize="11px"
                                                  fontWeight="600"
                                                  color="var(--Gray3)"
                                                >
                                                  <Text
                                                    textAlign="left"
                                                    fontWeight={salario <= nivel.primeiroQuartil ? '800' : '400'}
                                                    color={salario <= nivel.primeiroQuartil ? corSalario : 'var(--Gray3)'}
                                                  >
                                                    1º Quartil
                                                  </Text>
                                                  <Text
                                                    textAlign="center"
                                                    fontWeight={
                                                      salario > nivel.primeiroQuartil && salario < nivel.terceiroQuartil
                                                        ? '800'
                                                        : '400'
                                                    }
                                                    color={
                                                      salario > nivel.primeiroQuartil && salario < nivel.terceiroQuartil
                                                        ? corSalario
                                                        : 'var(--Gray3)'
                                                    }
                                                  >
                                                    Mediana
                                                  </Text>
                                                  <Text
                                                    textAlign="right"
                                                    fontWeight={salario >= nivel.terceiroQuartil ? '800' : '400'}
                                                    color={salario >= nivel.terceiroQuartil ? corSalario : 'var(--Gray3)'}
                                                  >
                                                    3º Quartil
                                                  </Text>
                                                </Grid>

                                                <Flex w="100%" align="center" position="relative">
                                                  <Box flex="1" h="2px" bg="var(--c5)" borderRadius="full" />
                                                  {['primeiroQuartil', 'mediana', 'terceiroQuartil'].map((campo, idx) => {
                                                    const valor = nivel[campo as keyof typeof nivel] as number
                                                    const isActive =
                                                      (campo === 'primeiroQuartil' && salario <= valor) ||
                                                      (campo === 'terceiroQuartil' && salario >= valor) ||
                                                      (campo === 'mediana' &&
                                                        salario > nivel.primeiroQuartil &&
                                                        salario < nivel.terceiroQuartil)

                                                    return (
                                                      <Box
                                                        key={idx}
                                                        position="absolute"
                                                        left={`${(idx / 2) * 100}%`}
                                                        transform="translateX(-50%)"
                                                        w="10px"
                                                        h="10px"
                                                        borderRadius="full"
                                                        bg={isActive ? corSalario : 'white'}
                                                        border={`2px solid ${isActive ? corSalario : 'var(--c5)'}`}
                                                      />
                                                    )
                                                  })}
                                                </Flex>
                                              </Flex>
                                              <Flex justifyContent={'end'}>
                                                <ElementoTooltipCmp bg={'var(--Rosa)'} label={'Visualizar colaborador'}>
                                                  <Flex
                                                    alignItems={'center'}
                                                    w={'1.75rem'}
                                                    h={'1.75rem'}
                                                    bg="transparent"
                                                    border={'1px solid var(--Rosa)'}
                                                    color={'var(--Rosa)'}
                                                    borderRadius={'50%'}
                                                    _hover={{ bg: 'var(--Rosa)', color: '#fff' }}
                                                    _focus={{ boxShadow: 'none' }}
                                                    justifyContent="center"
                                                    transition={'.2s'}
                                                    cursor={'pointer'}
                                                    onClick={() => { setColaborador(colab); setIsCollapsed(true) }}
                                                  >
                                                    <FaEye />
                                                  </Flex>
                                                </ElementoTooltipCmp>
                                              </Flex>
                                            </Grid>
                                              )
                                            })
                                          )}
                                    </AccordionPanel>
                                  </>
                                )}
                              </AccordionItem>
                            )
                          })
                        )
                      })()
                    }
                  </Accordion>
                </Flex>
              </WhiteContainer>
            )}
          </LoadingContainer>
        </Flex>
      </Body>
    </Flex>
  )
}
